var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('DataEntityList', {
    attrs: {
      "get-sort-list": _vm.wrapFunc(function (e) {
        return e;
      }),
      "get": _vm.$api.support.getStores
    },
    on: {
      "success": _vm.onSuccess
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var response = _ref.response,
            success = _ref.success,
            loading = _ref.loading;
        return [_c('div', {
          staticClass: "contact-page"
        }, [_c('div', {
          staticClass: "contact-page__wrapper"
        }, [_c('h1', {
          staticClass: "h1 contact-page__title"
        }, [_vm._v("\n        Интернет-магазин «05.ru»\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "contact-page__header"
        }, [_c('div', {
          staticClass: "contact-page__contact-block"
        }, [_c('div', {
          staticClass: "contact-page__contact-row"
        }, [_c('a', {
          staticClass: "contact-page__phone h3 link link_wu",
          attrs: {
            "href": ("tel:" + (_vm.formatPhone))
          }
        }, [_vm._v(_vm._s(_vm.socialStore.social.phone))]), _vm._v(" "), _c('a', {
          staticClass: "contact-page__contact-mail link link_wu link_blue h3",
          attrs: {
            "href": ("mailto:" + (_vm.socialStore.social.email))
          }
        }, [_vm._v("info@05.ru")])]), _vm._v(" "), _c('div', {
          staticClass: "contact-page__contact-row contact-page__contact-row_social"
        }, [_c('div', {
          staticClass: "contact-page__social-el contact-page__social-el_telegram"
        }, [_c('div', {
          staticClass: "contact-page__social-el-icon"
        }), _vm._v(" "), _c('div', [_c('a', {
          staticClass: "link link_wu contact-page__social-el-text",
          attrs: {
            "href": "https://teleg.run/www05ru_bot"
          }
        }, [_vm._v("Telegram - бот")])])]), _vm._v(" "), _c('div', {
          staticClass: "contact-page__social-el contact-page__social-el_youtube"
        }, [_c('div', {
          staticClass: "contact-page__social-el-icon"
        }), _vm._v(" "), _c('div', [_c('a', {
          staticClass: "link link_wu contact-page__social-el-text",
          attrs: {
            "href": _vm.socialStore.social.youTube
          }
        }, [_vm._v("YouTube")])])]), _vm._v(" "), _c('div', {
          staticClass: "contact-page__social-el contact-page__social-el_vk"
        }, [_c('div', {
          staticClass: "contact-page__social-el-icon"
        }), _vm._v(" "), _c('div', [_c('a', {
          staticClass: "link link_wu contact-page__social-el-text",
          attrs: {
            "href": _vm.socialStore.social.vk
          }
        }, [_vm._v("ВКонтакте")])])])])]), _vm._v(" "), _c('div', {
          staticClass: "contact-page__corp-block"
        }, [_c('div', {
          staticClass: "contact-page__corp-title b"
        }, [_vm._v("\n            Корпоративный отдел\n          ")]), _vm._v(" "), _c('a', {
          staticClass: "contact-page__corp-phone link link_wu b",
          attrs: {
            "href": ("tel:" + (_vm.formatPhone) + ",,1502")
          }
        }, [_vm._v(_vm._s(_vm.socialStore.social.phone)), _c('span', {
          staticClass: "contact-page__br"
        }), _vm._v(" (доб. 1502)")]), _vm._v(" "), _c('div', {
          staticClass: "contact-page__corp-time"
        }, [_vm._v("\n            Без выходных,"), _c('span', {
          staticClass: "contact-page__br"
        }), _vm._v(" с 09:00 до 19:00\n          ")]), _vm._v(" "), _c('a', {
          staticClass: "contact-page__corp-mail link link_wu link_blue",
          attrs: {
            "href": "mailto:corp@05.ru"
          }
        }, [_vm._v("corp@05.ru")])])]), _vm._v(" "), loading ? _c('div', {
          staticClass: "contact-page__cart-loading"
        }, [_c('StatusBlock', {
          attrs: {
            "type": "loading",
            "size": "l"
          }
        })], 1) : success ? _c('div', {
          staticClass: "contact-page__map-block"
        }, [_c('div', {
          staticClass: "contact-page__address"
        }, [_c('h3', {
          staticClass: "contact-page__address-title h4 mb-12"
        }, [_vm._v("\n            Адреса магазинов\n          ")]), _vm._v(" "), _c('ul', {
          staticClass: "address-list"
        }, _vm._l(_vm.storeList, function (address) {
          var _vm$value;

          return _c('li', {
            key: address.id,
            staticClass: "address-list__el",
            class: [{
              'address-list__el_active': ((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.id) === address.id
            }]
          }, [_c('span', {
            staticClass: "link",
            on: {
              "click": function ($event) {
                return _vm.onStoreClick(address);
              }
            }
          }, [_c('div', {
            staticClass: "address-list__main"
          }, [_c('b', [_vm._v(_vm._s(address.title))])]), _vm._v(" "), _c('div', {
            staticClass: "address-list__sub"
          }, [_vm._v("\n                  " + _vm._s(address.schedule) + "\n                ")])])]);
        }), 0)]), _vm._v(" "), _c('DeliveryMap', {
          attrs: {
            "zoom": _vm.zoom,
            "list": _vm.storeList,
            "value": _vm.value,
            "bounds": _vm.bound,
            "center": _vm.getMapCenter,
            "height": "530px"
          },
          on: {
            "change": _vm.onStoreClick
          }
        })], 1) : _vm._e()]), _vm._v(" "), response ? _c('SearchSemantic', {
          attrs: {
            "data": _vm.createSearchSemanticObj(response)
          }
        }) : _vm._e()], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }